import { ErrorLogger } from 'src/application-insights';
import { LitElement, html, css } from 'lit';
import { customElement, property, query } from 'lit/decorators.js'
import { actionBarStyles } from 'src/styles/action-bar';
import { services } from 'src/services';
import { TextArea } from '@microsoft/fast-foundation';
import {RadioButtonList, RadioButton} from 'src/components/radio-button-list'
import { raiseAsyncPromiseEvent } from 'src/modules/helpers/message-helper';
import  '../close-button';
import { CloseViewEvent } from 'src/events/close-view';
import { Button } from '@fluentui/web-components';
TextArea;
RadioButtonList;
RadioButton;
Button;

@customElement('page-feedback')
export class PageFeedback extends LitElement {
  static styles = [actionBarStyles,
    css`
      :host {
        box-sizing:border-box;
      }

      dialog[open] {
        border:0px;
        box-shadow: rgb(0 0 0 / 22%) 0px 25.6px 57.6px 0px, rgb(0 0 0 / 18%) 0px 4.8px 14.4px 0px;

        display:flex;
        flex-direction:column;
        gap:1rem;
      }

     dialog::backdrop {
        background: rgba(0, 0, 0, 0.4); 
     }

     .title-text {
        font-size:20px;
        font-weight:600;
     }

     .button-text {
      font-weight:600;
     }


      fluent-text-area::part(control)
      {
        width: 70vw;
        height:30vh;
        max-width:1000px;
      }
    `
  ];

  @query("dialog") private _dialog!: HTMLDialogElement;
  @query("fluent-text-area") private _textArea!: TextArea;

  @property({type:Number}) reportKey?:number;

  @property({ type: String }) heading?: string;
  @property({ type: String }) placeHolder?: string;

  private reset = ()=> {
    this._textArea.value = "";
  }

  protected submit = async () =>{
    if(this._textArea.reportValidity() === true)
    {

      try {
        this.#close();
        var task = async  () => {
          if(this.reportKey)
          {
            await services.users.sendFeedback(window.location.href, this._textArea.value, this.reportKey)
          } else {
            await services.users.sendFeedback(window.location.href,this._textArea.value)
          }
        }
       
        
        await raiseAsyncPromiseEvent<void>(this, task(), { success: "Message sent", failed: "Could not send message", progress: "Sending" } )
        this.reportKey = undefined;
        this.reset();

      }  
      catch(er) {
        ErrorLogger.logError(er);
        throw er;
      }
    }
  }
  showModal = () => this._dialog.showModal();
  #close =()=>{
    this._dialog.close();
  }
  
  #closeViewHandler =(e:CloseViewEvent)=>{
    this.#close();
    e.stopPropagation();
    e.preventDefault();
  }
    
  render = () => html`
      <dialog closedBy="any">
        <div class="action-bar">
          <mwc-icon>contact_support</mwc-icon>  
          <div class="title-text">${this.heading ?? "Feedback"}</div>
          <close-button class="push-right" @close-view=${this.#closeViewHandler}></close-button>
        </div>
        <div>
          <fluent-text-area  placeholder="${this.placeHolder ?? "Describe your experience"}" required></fluent-text-area>
        </div>
        <div class="action-bar">
          <fluent-button class="push-right button-text" appearance="accent" style="--control-corner-radius:0" @click=${this.submit} >Submit</fluent-button>
          <fluent-button class="button-text" appearance="outline"style="--control-corner-radius:0" @click=${() => this.#close()}>Cancel</fluent-button>
        </div>
      </dialog>
    `;
}
